const pluralize = (count: number, singular: string, plural?: string): string => {
  plural ||= count === 1 ? singular : `${singular}s`
  return `${count} ${count === 1 ? singular : plural}`
}

export { pluralize }
